import React, { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';

import { convertThumbnailToPictureImage } from '@tager/web-modules';

import { SchemaType } from '@/modules/Product/components/Main/components/Tabs/Tabs';
import Picture from '@/components/Picture';
import Spinner from '@/components/Spinner';
type Props = {
  data: SchemaType[];
  setHeight: (height: number) => void;
};

function Schema({ data, setHeight }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (ref.current) {
      setHeight(ref.current.scrollHeight);
    }
  });

  return (
    <Component ref={ref}>
      {data.map((schema, index) => (
        <Content key={index} className="schema-content">
          <Item>
            <Picture {...convertThumbnailToPictureImage(schema.original)} />
          </Item>
        </Content>
      ))}
    </Component>
  );
}

export default Schema;

const Component = styled.div`
  height: 100%;
  & > .schema-content:first-child {
    margin-top: 0;
  }
`;
const Content = styled.div`
  padding: 15px 0;
`;
const Item = styled.div``;
